import { VariantAlt } from 'stories/Button.stories';

import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import Button from 'components/common/Button/Button';
import ModalDialog from 'components/common/ModalDialog/ModalDialog';
import PlanTypeSelector from 'components/logic/PlanTypeSelector/PlanTypeSelector';
import PromoCode from 'components/logic/SubscribtionPlans/PromoCodeEnter/PromoCode';
import SubscribtionPlans from 'components/logic/SubscribtionPlans/SubscribtionPlans';
import useAuthentication from 'hooks/api/useAuthentication';
import requestAPI from 'utils/apiHandler';

//import style from './SubscribeModal.module.scss';

interface iProps {
  afterLogin: boolean;
}

export default ({ afterLogin }: iProps) => {
  const { t } = useTranslation();
  const [prices, setPrices] = useState<any>([]);
  const [filteredPries, setFilteredPrices] = useState<any>([]);
  const [selectedPrice, setSelectedPrice] = useState<string>('');
  const [cupon, setCupon] = useState<string>('');

  const [showModal, setShowModal] = useState<boolean>(false);

  const { logOut } = useAuthentication();
  const loadPrices = async () => {
    const response = await requestAPI('/prices');
    setPrices(response.data.prices);
  };
  const setupPriceData = () => {
    setFilteredPrices(prices);
    setSelectedPrice(prices[0]?.id ?? null);
  };

  useEffect(() => {
    if (!showModal) {
      return;
    }
    loadPrices();
  }, [showModal]);

  const submit = async () => {
    await requestAPI({
      url: '/prices',
      method: 'POST',
      data: {
        price: selectedPrice,
        cupon,
      },
    }).then(res => {
      window.location = res.data.url;
    });
  };

  useEffect(() => {
    setupPriceData();
  }, [prices]);

  useEffect(() => {
    setShowModal(afterLogin);
  }, []);

  // {paymentMehtods.length > 1 && (
  //   <div className={style.cardContainer}>
  //     {paymentMehtods.map(obj => {
  //       return (
  //         <div key={obj.id} className={style.card}>
  //           <div className={style.header}>
  //             <h3>{obj.brand}</h3>
  //             <p>{obj.expiration}</p>
  //           </div>
  //           <div>xxxx xxxx xxxx {obj.lastFour}</div>
  //         </div>
  //       );
  //     })}
  //   </div>
  // )}

  return (
    <>
      {!afterLogin && (
        <Button label={t('login:changePlan')} variant="secondary" onClick={() => setShowModal(true)} />
      )}

      <ModalDialog
        open={showModal}
        title={t('login:choosePackage')}
        onClose={() => {
          if (!afterLogin) {
            window.location.reload();
          }
        }}
        actions={[
          <Button key="save" onClick={submit} style={{ width: '100%' }} label={t('login:choose')} />,
          <Button
            key="logout"
            onClick={logOut}
            variant={'link'}
            style={{ width: '100%', display: afterLogin ? 'block' : 'hidden' }}
            label={t('login:logout')}
          />,
        ]}
      >
        <SubscribtionPlans
          activePlanId={selectedPrice}
          plans={filteredPries}
          selectedPlan={(val: any) => {
            setSelectedPrice(val.id);
          }}
        />
        <PromoCode updateCupon={setCupon} />
      </ModalDialog>
    </>
  );
};
